import type { Tooltip } from '@/types/common';

export enum TooltipDirection {
  Top = 'top',
  Bottom = 'bottom',
}

export enum TooltipPosition {
  Left = 'left',
  Right = 'right',
  Center = 'center',
}

export interface TooltipConfig {
  title?: string;
  text: string;
  direction: TooltipDirection;
  position: TooltipPosition;
  variant?: 'primary';
}

export interface Element {
  id: string;
  el: HTMLElement;
  tooltipConfig: TooltipConfig;
}

export interface Binding {
  modifiers: Record<string, string>;
  value: string | Tooltip;
}

export interface BindHookPayload {
  el: HTMLElement;
  binding: Binding;
}

export interface TooltipWithConfigFields extends Tooltip {
  classList: string[];
  style: Record<string, string>;
  position: TooltipPosition;
  direction: TooltipDirection;
  elementId?: string;
}
